import merge from 'lodash/merge'
import {
  toirMapissuesConfigDefault,
  toirMapissuesFieldsConf,
  toirMapissuesConfigColumnList,
  toirMapissuesDefaultFilterList,
  toirMapissuesDefaultViewList,
} from '@infotech/toir-4sides-front-core'

const { defaultModuleConfig } = toirMapissuesConfigDefault.config

const toirFieldsConfig = {}

export const fieldsConf = merge(
  {},
  toirMapissuesFieldsConf,
  toirFieldsConfig,
)

export const defaultColumnsList = toirMapissuesConfigColumnList

export const defaultViewList = toirMapissuesDefaultViewList

export const defaultFilterList = toirMapissuesDefaultFilterList

export const getFormConfig = (fieldsList, fieldsConfig, metadata) => (
  defaultModuleConfig.getFormConfig(fieldsList, fieldsConf, metadata)
)

export const getFilterConfig = (fieldsList, fieldsConfig, metadata) => (
  defaultModuleConfig.routing.list.filter.getFilterConfig(fieldsList, fieldsConf, metadata)
)

export const getViewConfig = (viewList, fieldsConfig, metadata) => (
  defaultModuleConfig.getViewConfig(defaultViewList, fieldsConf, metadata)
)

export const getGridConfig = (columnsList, fieldsConfig, metadata) => (
  defaultModuleConfig.getGridConfig(columnsList || defaultColumnsList, fieldsConf, metadata)
)

export const getAllColumns = (columnsList, fieldsConfig, metadata) => (
  defaultModuleConfig.routing.list.getAllColumns(defaultColumnsList, fieldsConf, metadata)
)

export const getAllFilters = (filtersList, fieldsConfig, metadata) => (
  defaultModuleConfig.routing.list.filter.getAllFilters(filtersList, fieldsConf, metadata)
)
